import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import UserContext from "../../UserProvider";
import { useContext } from "react";
import { BecomePremiumMember } from "../../components/BecomeAMember";
import {
  getEmoviToGuess,
  getGameNumber,
  START_DATE,
} from "../../services/utilities";

type DateNumberPair = {
  date: string;
  number: number;
  text: string;
};

export function ArchiveEmoviRoute() {
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);

  function generateDates(start: string): DateNumberPair[] {
    const startDate = dayjs(start);
    const today = dayjs();

    const dates: DateNumberPair[] = [];
    for (let d = startDate; d.isBefore(today); d = d.add(1, "day")) {
      const dateString = d.format("YYYY-MM-DD");
      const emoviToGuess = getEmoviToGuess(dateString);
      dates.push({
        date: dateString,
        number: getGameNumber(dateString),
        text: emoviToGuess.emojiText,
      });
    }

    return dates;
  }

  const games = generateDates(START_DATE);

  const playRandomGame = () => {
    const randomIndex = Math.floor(Math.random() * (games.length - 1));
    const randomGame = games[randomIndex];
    navigate(`/archive/${randomGame.date}`);
  };

  return (
    <>
      <div className="px-4 md:px-0">
        <div className="mb-4 mt-4">
          <Link to="/">
            <span className="text-blue-500 hover:text-blue-400">
              &#8592; Back
            </span>
          </Link>
        </div>
        <h2 className="text-xl font-bold mb-2">Archive</h2>
        {!userDetails?.premiumGames?.includes("emovi") && (
          <>
            <p className="mb-3">
              Access to the game archive is an exclusive feature for Premium
              Members. Register now through the link below and unlock the
              ability to play all the games that have ever existed!
            </p>
            <div className="flex flex-col gap-2 mb-3">
              <BecomePremiumMember />
            </div>
          </>
        )}
        {userDetails?.premiumGames?.includes("emovi") && (
          <div className="flex flex-col gap-2">
            <p className="mb-3">Here are all the games since 17th July 2022.</p>
            <div
              onClick={playRandomGame}
              className="text-center border border-black p-2 rounded-md shadow-sm hover:bg-slate-200 cursor-pointer mb-2"
            >
              Play a random game
            </div>
            <div className="grid grid-cols-2 gap-2">
              {games.reverse().map((game, i) => (
                <Link to={`/archive/${game.date}`} key={i}>
                  <div className="text-center border border-black p-2 rounded-md shadow-sm hover:bg-slate-200 cursor-pointer">
                    <p>Game {game.number}</p>
                    <p>{game.text}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
